import Image from "./image";
import Text from "./text/text";
import { useTranslation } from "react-i18next";
import { useFindPath } from "../hooks/useFindPath";
import { CHAT_TYPE } from "../types/navigation-mode";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "@/store/appStore";
import { useLanguageStore } from "@/store/languageStore";
import { useNavigationStore } from "@/store/navigationStore";

interface ExampleItemProps {
  type: (typeof CHAT_TYPE)[keyof typeof CHAT_TYPE];
  question: string;
  onClick?: () => void;
  className?: string;
}

const ExampleItem: React.FC<ExampleItemProps> = ({
  type,
  question,
  onClick,
  className = "",
}) => {
  const { t } = useTranslation();
  const { handleUserQuery } = useFindPath(true);
  const setChatType = useAppStore((state) => state.setChatType);
  const setVoiceOn = useLanguageStore((state) => state.setVoiceOn);
  const setUserQuery = useNavigationStore((state) => state.setUserQuery);

  let navigate = useNavigate();

  const handleFindNavPath = async () => {
    if (onClick) {
      onClick();
    }

    setChatType(type);
    setUserQuery(t(question));

    if (type == CHAT_TYPE.NAVIGATION) {
      setVoiceOn(false);
      await handleUserQuery(t(question));
    } else if (type == CHAT_TYPE.SIMULATION) {
      setVoiceOn(true);
      navigate("/simulation");
    }
  };

  return (
    <div
      className={`flex items-center justify-between p-4 cursor-pointer rounded-lg transition-colors duration-200 example-item ${className}`}
      onClick={handleFindNavPath}
    >
      <Text text={question} className="text-white" />
      <Image
        aria-hidden
        src="/assets/icon_next.png"
        alt="next icon"
        width={20}
        height={20}
      />
    </div>
  );
};

export default ExampleItem;
